import * as React from 'react';
import Switch from '../../../../atoms/Switch/Switch.js';
import { CookieTypeContainer, CookieTypeTopRow, CookieTypeTitle, EssentialLabel, PreferenceDescription } from './PreferenceItem.styles.js';

var PreferenceItem = function (_a) {
    var label = _a.label, description = _a.description, checkboxLabel = _a.checkboxLabel, checked = _a.checked, onChange = _a.onChange, alwaysActive = _a.alwaysActive;
    return (React.createElement(CookieTypeContainer, null,
        React.createElement(CookieTypeTopRow, { "data-testid": "".concat(label, "-cookie-type"), 
            // legav for rails to not apply additional styles to this
            className: "styled-label" },
            React.createElement(CookieTypeTitle, { as: "h5" }, label),
            alwaysActive ? (React.createElement(EssentialLabel, { as: "span", variant: "caption" }, checkboxLabel)) : (React.createElement(Switch, { variant: checked ? "active" : "default", checked: checked, labelText: checkboxLabel, onCheckedChange: onChange }))),
        React.createElement(PreferenceDescription, { as: "p", variant: "footnote" }, description)));
};

export { PreferenceItem as default };
//# sourceMappingURL=PreferenceItem.js.map
